
import { defineComponent } from 'vue';
import Posts from '@/components/Posts.vue';

export default defineComponent({
    name: 'blog',

    components: { Posts },

    setup() {
        document.title = 'Home | Vue3 Blog';
    },
});
